module.exports = __webpack_public_path__ + "static/media/pago-pa.b2292f22.svg";